import { AppTreeSide, UniDateRangePicker } from 'components'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import {getOneWeekBeginAndEndDate} from '@/utils/date'

export default {
  name: 'SystemLogs',
  data () {
    return {
      // 活动页面索引
      activeTabName: '0',
      // 遮罩层
      loading: false,
      // 日志记录页面--------------------------------------------------------------------------------------------------
      // 表格数据
      logTableData: [],
      logTableTotalRow: 0,
      // 表格查询条件
      logDates: [], // 查询起始和结束日期
      logTableQueryParams: {
        lastLogId: 0,
        logType: 2, // 系统日志
        logSubType: 0, //
        beginOperationDateTime: 0,
        endOperationDateTime: 0,
        userName: '', //
        hostIp: '', //
        orderBy: 1, // 排序方式,0-增序，1-减序
        pageNum: 1,
        pageSize: 15
      },
      // 表格选中记录数组
      logTableSelectedIds: [],
      // 日志表格当前行
      logTableCurrentRow: null,
      // 日志信息弹窗
      showLogModalOpen: false,
      // 轮巡定时器
      pollingTimer: null
    }
  },
  components: {
    AppTreeSide,
    UniDateRangePicker
  },
  mixins: [
    ssoLoginMixin,
    convertorMixin,
    idNameMixin
  ],
  watch: {
    // 根据名称筛选节点
    treeNodeFilter(val) {
      this.$refs.tree.filter(val.trim())
    }
  },
  mounted () {
    // 设置查询起始日期和截止日期
    this.logDates = getOneWeekBeginAndEndDate() // 近一周

    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 查询日志列表
      this.getHistoryLogList()
    })
  },
  methods: {
    // 查询日志列表
    getHistoryLogList() {
      this.loading = true
      this.logTableQueryParams.beginOperationDateTime = this.logDates[0].getTime() / 1000
      this.logTableQueryParams.endOperationDateTime = this.logDates[1].getTime() / 1000
      this.$http(this.$api.historyLogList, this.logTableQueryParams).then(
        res => {
          if (res.code === 200) {
            this.logTableData = res.data
            this.logTableTotalRow = res.page.totalRow
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // tab页面切换
    handleTabClick(tab) {
      if (tab.name === '0') {
        if (this.logTableTotalRow === 0) {
          this.getHistoryLogList()
        }
      }
    },
    // 日志记录页面------------------------------------------------------------------------------------------------
    // 查询按钮操作
    handleLogFormQuery() {
      this.logTableQueryParams.page = 1
      this.getHistoryLogList()
    },
    // 重置按钮操作
    resetLogQueryForm() {
      this.logTableQueryParams.logType = 1
      this.logTableQueryParams.logSubType = 0
      this.logDates = getOneWeekBeginAndEndDate() // 近一周
      this.logTableQueryParams.beginOperationDateTime = 0
      this.logTableQueryParams.endOperationDateTime = 0
      this.logTableQueryParams.userName = ''
      this.logTableQueryParams.hostIp = ''
      this.logTableQueryParams.pageNum = 1
      this.$refs['logQueryForm'].resetFields()
      this.handleLogFormQuery()
    },
    // 分页
    handleLogCurrentPageChange(val) {
      this.logTableQueryParams.pageNum = val
      this.getHistoryLogList()
    },
    // 页面条数改变
    handleLogPageSizeChange(val) {
      this.logTableQueryParams.pageSize = val
      this.getHistoryLogList()
    },
    // 表格选中记录改变
    handleLogTableSelectionChange(selection) {
      this.logTableSelectedIds = selection.map(item => item.id)
    },
    // 查看日志
    handleLogView(row) {
      if (row && row.id) {
        this.$refs.logTable.setCurrentRow(row) // 选中当前行
        this.showLogModalOpen = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/events/SystemLogs/SystemLogs.js